<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-labelledby="Facebook" role="img">
  <path
    d="M13.261 8.79639C13.261 8.48216 13.3436 8.07931 13.4263 7.99874C13.5089 7.83759 13.8313 7.68451 14.1619 7.68451H15.9556L16.1209 4.74366L15.7159 4.66309C15.4679 4.66309 14.5752 4.58252 13.5172 4.58252C12.3765 4.58252 11.4756 4.97732 10.8226 5.61383C10.087 6.33091 10.0043 7.36222 10.0043 8.55468V10.0694H7.54944V13.1714H9.99606V20.4067H13.261V13.1714H15.5423L16.0299 10.0694H13.261V8.79639Z"
  />
</svg>
